const DisableMobile = () => {
  return (
      <div className="m-disablemobile">
        <h2>This website won't work properly on your device,</h2>
        <h2>Please view this website on a bigger screen.</h2>
      </div>
  )
}

export default DisableMobile